import React, { ReactNode } from "react";
import { SmartLink } from "./SmartLink";

interface Props {
    className?: string;
    url: string;
    target: string;
    title: ReactNode;
}

export const CMSLink: React.FC<Props> = props => {
    return (
        <SmartLink className={props.className} to={props.url} target={props.target}>
            {props.title}
        </SmartLink>
    );
};
